import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useLogPageViews = () => {
	const location = useLocation();

	useEffect(() => {
		console.log("Page view:", location.pathname + location.search + location.hash);
	}, [location]);
};

export default useLogPageViews;
